const NotFoundPage = () => {
  return (
    <div className="grid-container">
      <h1 className="text-center">Not Found page</h1>
    </div>
  )
}

export default NotFoundPage